import React from "react";
import { BetQLSportItem } from "src/common-services";
import styles from "./styles.scss";
import GameDetailNav from "./Nav";
import GameHeader from "src/components/GameHeader";
import { EventDetails } from "src/services/miniql";

const GameDetailHeader = ({
  game,
  currentSportObj,
  lineFilter,
  prismicGame,
  eventDetails,
}: {
  game: any;
  currentSportObj: BetQLSportItem;
  lineFilter: string;
  prismicGame: any;
  eventDetails?: EventDetails;
}) => {
  return (
    <React.Fragment>
      {/* Mobile Nav */}
      <div className="d-md-none">
        <GameDetailNav
          game={game}
          currentSportObj={currentSportObj}
          lineFilter={lineFilter}
          prismicGame={prismicGame}
        />
      </div>
      <div className="game-detail-header">
        <div className="game-detail-header-inner">
          <GameHeader game={game} showRating={currentSportObj.key !== "WC"} eventDetails={eventDetails} />
          {/* Desktop Nav */}
          <div className="d-none d-md-block">
            <GameDetailNav
              game={game}
              currentSportObj={currentSportObj}
              lineFilter={lineFilter}
              prismicGame={prismicGame}
            />
          </div>
        </div>
      </div>
      <style jsx global>
        {styles}
      </style>
    </React.Fragment>
  );
};

export default GameDetailHeader;
